import { User } from "@/models/users/User";
import { formatUserAvatarFallback } from "@/utils/format";
import { Avatar, AvatarFallback, AvatarImage } from "@capacit-com/lara-law-shared-ui";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

type UserAvatarProps = {
  user: User | undefined | null;
  avatarClassName?: string;
  avatarStyle?: ComponentProps<typeof Avatar>["style"];
  fallbackClassName?: string;
  imageClassName?: string;
};

const UserAvatar = ({
  user,
  avatarClassName,
  avatarStyle,
  imageClassName,
  fallbackClassName,
}: UserAvatarProps) => {
  return (
    <Avatar className={avatarClassName ?? "size-6"} style={avatarStyle}>
      <AvatarImage
        className={imageClassName}
        src={user?.profilePictureUrl}
        alt={user?.firstName ?? user?.email}
      />
      <AvatarFallback
        className={cn(
          // Use absolute positioning for perfect centering
          "absolute inset-0 flex items-center justify-center",
          // Our custom classes
          "text-[10px] leading-none select-none",
          // User-provided classes (can override above)
          fallbackClassName
        )}
      >
        {formatUserAvatarFallback(user)}
      </AvatarFallback>
    </Avatar>
  );
};

export default UserAvatar;
